/**
 * Analytics helper — Umami usage events (framing V12 / S-D6).
 *
 * One wrapper over the Umami script loaded in index.html. Event names are
 * kebab-case singular; properties never carry personal data.
 */

type EventProps = Record<string, string | number | boolean>;

interface UmamiApi {
  track: (name: string, data?: EventProps) => void;
}

declare global {
  interface Window {
    umami?: UmamiApi;
  }
}

/** Fire an event if Umami is present; never throws. */
export function track(name: string, props?: EventProps): void {
  try {
    window.umami?.track(name, props);
  } catch {
    /* analytics must never break the app */
  }
}
